/**
 * Created by JackCui on 2021/12/20
 */

import projectInfo from '../utils/project-info.js'

// 按钮埋点固定key
export const DATA_SPM_KEY = 'data-spm-d'

// 固定系统内按钮分端后的apiName
export const BUTTON_API_NAME = ((project) => {
  return ({
    'pur': {
      'BUTTON_CREATE': 'company_button_create',
      'BUTTON_UPDATE': 'company_button_update',
      'BUTTON_DETAIL': 'company_button_detail',
      'BUTTON_DELETE': 'company_button_delete',
      'BUTTON_BATCH_DELETE': 'company_button_batch_delete',
      'BUTTON_IMPORT': 'company_button_import',
      'BUTTON_EXPORT': 'company_button_export',
      'BUTTON_BACK': 'company_button_back',
      'BUTTON_MODIFY_LEADER': 'company_button_modify_leader'
    },
    'sur': {
      'BUTTON_CREATE': 'company_sur_button_create',
      'BUTTON_UPDATE': 'company_sur_button_update',
      'BUTTON_DETAIL': 'company_sur_button_detail',
      'BUTTON_DELETE': 'company_sur_button_delete',
      'BUTTON_BATCH_DELETE': 'company_sur_button_batch_delete',
      'BUTTON_IMPORT': 'company_sur_button_import',
      'BUTTON_EXPORT': 'company_sur_button_export',
      'BUTTON_BACK': 'company_sur_button_back',
      'BUTTON_MODIFY_LEADER': 'company_sur_button_modify_leader'
    }
  })[project]
})(projectInfo.query())

export const FORM_POSITION_SPAN = {
  'left': '2',
  'right': '2',
  'top': '3'
}

export const _findObjKey = function (obj, value, compare = (a, b) => a === b) {
  return Object.values(obj).find(k => compare(k, value))
}

// 页面类型 新增编辑详情
export const PAGE_STATUS_MAP = {
  ADD: 'layout_type_create',
  EDIT: 'layout_type_update',
  DETAIL: 'layout_type_detail',
  POLYMERIC_DETAIL: 'layout_type_polymeric_detail',
  POLYMERIC_CREATE: 'layout_type_polymeric_create'
}
